import React from "react";
import { Users, Gauge, AlertOctagon, TrendingUp } from "lucide-react";

const fmt = (n) => (n ?? 0).toLocaleString("en-IN");

const Tile = ({ icon: Icon, label, value, sub, accent, testid }) => (
  <div className="panel p-3 flex flex-col gap-0.5 min-w-0" data-testid={testid}>
    <div className="flex items-center justify-between">
      <span className="micro-label">{label}</span>
      <Icon className="w-3.5 h-3.5 text-muted-foreground" strokeWidth={1.5} />
    </div>
    <div className={`font-mono text-2xl font-semibold tracking-tighter leading-none mt-1 ${accent || ""}`}>
      {value}
    </div>
    <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mt-0.5 truncate">
      {sub}
    </div>
  </div>
);

export const CrowdSummary = ({ summary }) => {
  const total = summary?.total_occupancy ?? 0;
  const cap = summary?.total_capacity ?? 0;
  const pct = cap ? Math.round((total / cap) * 100) : 0;
  const avgDensity = Math.round((summary?.avg_density ?? 0) * 100);
  const peak = summary?.peak_zone;
  const crit = summary?.critical_zones ?? 0;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
      <Tile
        icon={Users}
        label="People In Venue"
        value={fmt(total)}
        sub={`${pct}% of ${fmt(cap)}`}
        testid="crowd-kpi-people"
      />
      <Tile
        icon={Gauge}
        label="Avg Density"
        value={`${avgDensity}%`}
        sub={avgDensity >= 70 ? "Elevated" : "Nominal"}
        accent={avgDensity >= 85 ? "sev-critical" : avgDensity >= 70 ? "sev-medium" : ""}
        testid="crowd-kpi-density"
      />
      <Tile
        icon={TrendingUp}
        label="Peak Zone"
        value={peak ? `${Math.round((peak.pct ?? 0) * 100)}%` : "—"}
        sub={peak?.name ?? "—"}
        accent={peak && peak.pct >= 0.85 ? "sev-critical" : peak && peak.pct >= 0.7 ? "sev-medium" : ""}
        testid="crowd-kpi-peak"
      />
      <Tile
        icon={AlertOctagon}
        label="Critical Zones"
        value={crit}
        sub={crit > 0 ? "≥ 85% capacity" : "all zones below threshold"}
        accent={crit > 0 ? "sev-critical" : ""}
        testid="crowd-kpi-critical"
      />
    </div>
  );
};

export default CrowdSummary;
